<template>
  <div
    class="income-tax-calculator__content"
    data-testid="income-tax-calculator-content"
  >
    <header class="income-tax-calculator__content__header">
      <InitialAvatarIcon
        class="income-tax-calculator__content__header__icon"
        icon="BB0040"
        size="large"
      />
      <Heading
        class="income-tax-calculator__content__header__title"
        :level="2"
        as="h1"
        >{{ data.title }}</Heading
      >
      <BaseText
        class="income-tax-calculator__content__header__description"
        size="lg"
        :color="NebraskaColors.textSecondary"
        >{{ data.description }}</BaseText
      >
    </header>
    <template v-for="(card, index) in data.cards">
      <ContentDisplay :key="index" class="income-tax-calculator__content__card">
        <template #content-block-1>
          <Heading
            class="income-tax-calculator__content__card__title"
            :level="4"
            as="h2"
            >{{ card.title }}</Heading
          >
          <BaseText size="md" :color="NebraskaColors.textSecondary">{{
            card.description
          }}</BaseText>
        </template>
      </ContentDisplay>
    </template>
    <BaseText
      size="sm"
      :color="NebraskaColors.textSecondary"
      class="income-tax-calculator__content__disclaimer"
    >
      {{ data.disclaimer }}
    </BaseText>
  </div>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';

import {
  ContentDisplay,
  InitialAvatarIcon,
  Heading,
  BaseText
} from '@warrenbrasil/nebraska-web';

import { NebraskaColors } from '@warrenbrasil/nebraska-tokens-web';
import { data } from '../../data';
import { ViewStatus } from '../../types';

@Component({
  components: {
    ContentDisplay,
    InitialAvatarIcon,
    Heading,
    BaseText
  }
})
export default class TaxCalculatorContent extends Vue {
  readonly NebraskaColors = NebraskaColors;
  readonly data = data;
  readonly ViewStatus = ViewStatus;
}
</script>

<style lang="less" scoped>
.income-tax-calculator {
  &__content {
    max-width: 592px;
    box-sizing: content-box;
    padding-left: @size-spacing-x500;
    padding-right: @size-spacing-x500;
    margin: 0 auto;

    &__header {
      text-align: center;
      margin-top: @size-spacing-x700;
      margin-bottom: @size-spacing-x900;

      &__icon {
        margin-bottom: @size-spacing-x500;
      }

      &__title {
        margin-bottom: @size-spacing-x400;
      }
    }

    &__card {
      margin-bottom: @size-spacing-x500;

      &__title {
        margin-bottom: @size-spacing-x400;
      }
    }

    &__disclaimer {
      margin-top: @size-spacing-x300;
      margin-bottom: @size-spacing-x900;
    }
  }
}
</style>
